<template>
    <mobile-panel-wrapper
        :is-open="isOpen" :element-height="elementHeight"
        class="items-center"
        :overflow="isOpenQuantitySelector ? 'visible' : 'hidden'">
        <div class="flex items-center mb-3 w-full flex-col justify-center max-w-md mx-auto">
            <div class="text-2xl md:text-3xl uppercase font-extrabold text-center">
                {{viewController?.blueprint?.name}}
            </div>
        </div>
        <horizontal-scroll-outer-wrapper>
            <horizontal-scroll-inner-wrapper class="py-2">
                <button
                    class="flex flex-col flex-shrink-0 justify-center items-center cursor-pointer mx-6 w-12 cz__tour__small-colors"
                    @click="selectStep('colors')">
                    <div class="h-8 w-8 border border-stone-800 flex items-center justify-center rounded-full mb-2">
                        <div
                            class="h-6 w-6 rounded-full"
                            :style="{ backgroundColor: selectedColorHex }" />
                    </div>
                    <div>
                        {{$t('MENU_COLORS')}}
                    </div>
                </button>
                <div
                    class="flex flex-col flex-shrink-0 justify-center items-center cursor-pointer mx-6 w-12" @click="selectStep('group')"
                    v-if="isGroupOrder">
                    <img src="../../../assets/group.svg" class="h-8 w-8 mt-4">
                    <div class="text-center mt-4">
                        {{$t('GROUP_INFORMATION')}}
                    </div>
                </div>
                <button
                    class="flex flex-col flex-shrink-0 justify-center items-center cursor-pointer mx-6 w-12 cz__tour__small-images"
                    @click="selectStep('images')">
                    <img src="../../../assets/logo.svg" class="h-8 w-8 mb-2">
                    <div>
                        {{$t('MENU_IMAGES')}}
                    </div>
                </button>
                <button
                    class="flex flex-col flex-shrink-0 justify-center items-center cursor-pointer mx-6 w-12 cz__tour__small-text"
                    @click="selectStep('text')">
                    <img src="../../../assets/text.svg" class="h-8 w-8 mb-2">
                    <div>
                        {{$t('MENU_TEXT')}}
                    </div>
                </button>
                <div
                    class="flex flex-col flex-shrink-0 justify-center items-center cursor-pointer mx-6 w-12" @click="selectStep('monogram')"
                    v-if="!isGroupOrder">
                    <img src="../../../assets/monogram.svg" class="h-8 w-8 mb-2">
                    <div>
                        {{$t('MENU_MONOGRAM')}}
                    </div>
                </div>
            </horizontal-scroll-inner-wrapper>
        </horizontal-scroll-outer-wrapper>
        <div class="flex items-center mt-4 w-full max-w-md mx-auto" v-if="!isGroupOrder">
            <number-selector
                :is-open="isOpenQuantitySelector"
                @open="isOpenQuantitySelector = true"
                @close="isOpenQuantitySelector = false"
                :value="quantity" :min="1"
                :max="maxQuantity" @select="setQuantity($event)"
                @decrease="setQuantity(quantity - 1)" @increase="setQuantity(quantity + 1)" />
            <primary-button
                class="text-lg"
                :tour-class="'cz__tour__small-done'"
                @click="selectStep('review')">
                {{ $t('ACTION_DONE') }}
            </primary-button>
        </div>
        <div class="flex w-full" v-else>
            <primary-button class="text-lg" @click="selectStep('review')">
                {{ $t('ACTION_DONE') }}
            </primary-button>
        </div>
    </mobile-panel-wrapper>
</template>

<script>
    import {
        mapState,
        mapActions,
        mapGetters,
    } from 'vuex';
    import NumberSelector from '../../NumberSelector.vue';

    import MobilePanelWrapper from './MobilePanelWrapper.vue';
    import HorizontalScrollOuterWrapper from '../../HorizontalScrollOuterWrapper.vue';
    import HorizontalScrollInnerWrapper from '../../HorizontalScrollInnerWrapper.vue';
    import PrimaryButton from '../../buttons/PrimaryButton.vue';

    export default {
        data() {
            return {
                group: 'individual',
                isOpenQuantitySelector: false,
            };
        },
        props: {
            isOpen: {
                type: Boolean,
                default: false,
            },
            elementHeight: {
                type: String,
                required: true,
            },
        },
        components: {
            MobilePanelWrapper,
            NumberSelector,
            HorizontalScrollOuterWrapper,
            HorizontalScrollInnerWrapper,
            PrimaryButton,
        },

        computed: {
            ...mapState({
                selectedStep: ({ selectedStep }) => selectedStep,
                isGroupOrder: ({ isGroupOrder }) => isGroupOrder,
                viewController: ({ customizer }) => customizer.viewController,
                secondaryBottles: ({ customizer }) => customizer.secondaryBottles || [],
                selectedBottle: ({ customizer }) => customizer.selectedBottle,
                quantity: (state) => state.customizer.quantity,
            }),
            ...mapGetters({
                maxQuantity: 'availableQuantity',
                colorStepCaption: 'colorStepTitle',
                selectedColorHex: 'selectedColorHex',
            }),
        },

        methods: {
            ...mapActions({
                selectStep: 'selectStep',
                setQuantity: 'setQuantity',
            }),
            handleSelectStep(step, parameters) {
                if (this.isGroupOrder) {
                    // Switch to the primary bottle first.
                    if (this.secondaryBottles.indexOf(this.selectedBottle) !== 0) {
                        this.$store.dispatch('setSelectedBottle', this.secondaryBottles[0]).then(() => {
                            this.selectStep({ step, parameters });
                        });
                    } else {
                        this.selectStep({ step, parameters });
                    }
                } else {
                    this.selectStep({ step, parameters });
                }
            },
        },
    };
</script>
